export const iconFontAwesomeHumanitarianTrainSubway = (
	<i className="fa-solid fa-train-subway"></i>
);
